exports.linkComponent = require("gatsby-link").default;
